import { ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { SSO_VENDOR_IDS } from "common/vendor-sso-links";
import { useCareFinderEnabled } from "hooks/use-care-finder-enabled/use-care-finder-enabled.hook";

type Props = { children: ReactNode };

// Android parity (`SSORouteInterceptor.kt`): the Find Care entry point is
// either the SSO link-out to EmblemHealth's portal or the in-app Care Finder
// capability, decided by `rel_mps_enableCareFinder`. Any other vendorId
// reaches the SSO page untouched, flag on or off.
export const FindCareRouteGuard = ({ children }: Props) => {
  const [searchParams] = useSearchParams();
  const { enabled, isLoading } = useCareFinderEnabled();

  if (searchParams.get("vendorId") !== SSO_VENDOR_IDS.FIND_CARE) {
    return children as JSX.Element;
  }
  // Hold on a spinner instead of starting the SSO flow — `SsoVendorPage`
  // opens the partner tab from an effect, which can't be taken back if the
  // flag then resolves to on.
  if (isLoading) return <LoadingIndicator />;
  if (enabled) {
    return (
      <Navigate to={getModulePath(LEAGUE_MODULE_NAMES.careFinder)} replace />
    );
  }
  return children as JSX.Element;
};
